import templateUrl from 'emun.report/job-scheduler/job-scheduler-prompt.htm'
import angular from 'angular'
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import modals from 'webmodals/modals'
import QuickReportParamsPrompt from "emun.report/quick-report-params";
import ReportParamsPrompt from "emun.report/report-params";

class controller {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.request = {
            meta: {}
        };
		if (options.job) $ctrl.request = options.job;
        $ctrl.bus = new ServiceBus();
        $ctrl.title = options.title || ' Scheduled Job...';
        $ctrl.jobTypes = ['Email QuickReport', 'Email Report'];
        $ctrl.frequencies = ['Daily', 'Weekly'];
        $ctrl.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		var timezone = moment.tz.guess();
        $ctrl.offset = moment.tz(timezone).utcOffset() / 60;
        $ctrl.hours = [
            {
                label: '12:00 am',
                id: '24'
            },
            {
                label: '1:00 am',
                id: '1'
            },
            {
                label: '2:00 am',
                id: '2'
            },
            {
                label: '3:00 am',
                id: '3'
            },
            {
                label: '4:00 am',
                id: '4'
            },
            {
                label: '5:00 am',
                id: '5'
            },
            {
                label: '6:00 am',
                id: '6'
            },
            {
                label: '7:00 am',
                id: '7'
            },
            {
                label: '8:00 am',
                id: '8'
            },
            {
                label: '9:00 am',
                id: '9'
            },
            {
                label: '10:00 am',
                id: '10'
            },
            {
                label: '11:00 am',
                id: '11'
            },
            {
                label: '12:00 pm',
                id: '12'
            },
            {
                label: '1:00 pm',
                id: '13'
            },
            {
                label: '2:00 pm',
                id: '14'
            },
            {
                label: '3:00 pm',
                id: '15'
            },
            {
                label: '4:00 pm',
                id: '16'
            },
            {
                label: '5:00 pm',
                id: '17'
            },
            {
                label: '6:00 pm',
                id: '18'
            },
            {
                label: '7:00 pm',
                id: '19'
            },
            {
                label: '8:00 pm',
                id: '20'
            },
            {
                label: '9:00 pm',
                id: '21'
            },
            {
                label: '10:00 pm',
                id: '22'
            },
            {
                label: '11:00 pm',
                id: '23'
            }
        ];
        $ctrl.bus.send("QueryUsers.json?RolesNotIn=Retailer").then(function(res) {
            $ctrl.users = res.data.results;
            if ($ctrl.request.id && $ctrl.request.hour) {
                $ctrl.request.hour = Number($ctrl.request.hour) + $ctrl.offset;
                $ctrl.hour = $ctrl.hours.filter(h => h.id == $ctrl.request.hour)[0];
                if ($ctrl.request.meta && $ctrl.request.meta["To"]) {
                    $ctrl.emails = $ctrl.request.meta["To"].split(",");
                    if ($ctrl.emails) {
                        $ctrl.emails.forEach(function (email) {
                            var orderEmail = $ctrl.users.filter(function (obj) {
                                return obj.email === email;
                            });
                            if (
                                orderEmail === null ||
                                (orderEmail.length === 0 && email && email !== "")
                            ) {
                                var contact = {
                                fullName: "no name",
                                email: email,
                                };
                                $ctrl.users.push(contact);
                            }
                        });
                    }
                }
            }
        });

        $ctrl.bus.send("QueryQuickReports.json").then(function(res) {
            $ctrl.quickreports = res.data.results;
            if ($ctrl.request.id && $ctrl.request.jobRoute) {
                $ctrl.filteredQuickReports = $ctrl.quickreports.filter(r => r.id == $ctrl.request.jobRoute);
                if ($ctrl.filteredQuickReports.length) {
                    $ctrl.quickreport = $ctrl.filteredQuickReports[0];
                    $ctrl.selectQuickReport();
                }
            }
        });
        $ctrl.bus.send("QueryReports.json").then(function(res) {
            $ctrl.reports = res.data.results;
            // $ctrl.reports.map(r => {
            //     if(r.name.indexOf("_") > -1) {
            //         r.name = r.name.substring(r.name.indexOf("_") + 1);
            //     }
            // });
            if ($ctrl.request.id && $ctrl.request.jobRoute) {
                $ctrl.filteredReports = $ctrl.reports.filter(r => r.name == $ctrl.request.jobRoute);
                if ($ctrl.filteredReports.length) {
                    $ctrl.report = $ctrl.filteredReports[0];
                    $ctrl.selectReport();
                }
            }
        });
    }

    selectReport() {
        const $ctrl = this;
        if (!$ctrl.request.jobDescription) $ctrl.request.jobDescription = $ctrl.report.displayName;
        $ctrl.hasParams = true;
    }

    selectQuickReport() {
        const $ctrl = this;
        var string = $ctrl.quickreport.query;
        $ctrl.arrParams = (string.match(/(?:^|[ ])@([a-zA-Z0-9]+)/gm) + "").split(",");
        $ctrl.hasParams = !($ctrl.arrParams.length == 0 || ($ctrl.arrParams.length == 1 && $ctrl.arrParams[0] == "null"));
        if ($ctrl.request.meta && $ctrl.request.meta["params"]) $ctrl.jsonParams = JSON.parse($ctrl.request.meta["params"]);
        if (!$ctrl.request.jobDescription) $ctrl.request.jobDescription = $ctrl.quickreport.name;
    }

    setParams() {
        const $ctrl = this;
        if ($ctrl.hasParams) {
            if ($ctrl.request.jobType == "Email Report") {
                ReportParamsPrompt({
                    report: $ctrl.report,
                    paramsOnly: true
                  }).then((res) => {
                    $ctrl.request.meta["SubmissionId"] = res;
                  });
            } else if($ctrl.request.jobType == "Email QuickReport") {
                QuickReportParamsPrompt.open({
                    model: { params: $ctrl.arrParams, report: $ctrl.report },
                    paramsOnly: true
                  }).then((res) => {
                    $ctrl.jsonParams = res;
                    $ctrl.request.meta["params"] = JSON.stringify(res);
                  });
            }
        }
    }

    parseEmail(item, model) {
        let $ctrl = this;
        $ctrl.request.meta["To"] = $ctrl.emails.join(",");
    }

    addEmail(search) {
        let $ctrl = this;
        var user = {
          fullName: "no name",
          email: search,
        };
        return user;
    }
    
    
    submit() {
        const $ctrl = this;
        $ctrl.request.hour = Number($ctrl.hour.id) + (Number($ctrl.offset)*-1);
        if ($ctrl.request.hour > 24) $ctrl.request.hour = $ctrl.request.hour - 24;
        $ctrl.request.jobRoute = $ctrl.request.jobType == "Email QuickReport" ? $ctrl.quickreport.id : $ctrl.request.jobType == "Email Report" ? $ctrl.report.name : "";
        $ctrl.request.meta.To = $ctrl.emails.join(",");
        $ctrl.bus.send(`${$ctrl.request.id ? 'Upd' : 'Cre'}ateScheduledJob.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.$broadcast("$scheduledJobSaved");
                $ctrl.$close($ctrl.request);
            });
    }
}

export default {
    open(options) {
        return modals.open(angular.extend({
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};
